export enum TRANSFER_STATUS {
  CREATED = "CREATED",
  ACCEPTED = "ACCEPTED",
  FAILED = "FAILED",
}
